import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure4 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    height: '600px',
    backgroundColor: 'rgba(255, 255, 255, 0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },
  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },
  exporting: {
    enabled: false
  },
  legend: {
    enabled: false,
  },
  xAxis: [{
    categories: ['2015', '2016', '2017', '2018', '2019', '2020*', '2021*', '2022*'],
    tickInterval: 1,
    crosshair: {
      width: 1,
      color: '#d7d7d7'
    },
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {
      y: 32,
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
    min: 0, // Set the minimum value to 0 to start at the first data point
    max: 7, // Set the maximum value to 7 to end at the last data point
  }],

  yAxis: [
    {
      labels: {
        format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      gridLineWidth: 2,
      max: 25,
      min: 0,
      tickInterval: 5,
      title: {
        text: "Pourcentage",
        style: {
          fontSize: '18px',
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  plotOptions: {
    series: {
      states: {
        hover: {
          lineWidth: 2
        }
      },
      marker: {
        symbol: 'circle',
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  series: [

    {
      marker: {
        enabled: false
      },
      name: 'Afrique subsaharienne',
      type: 'line',
      color: '#c00000',
      zoneAxis: 'x',
      data: [
        {
          y: 18.2,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#c00000',
            lineColor: '#c00000',
            lineWidth: 2
          }
        },
        19.1, 18.9, 19.1, 19.5, 21.6, {
          y: 22.2,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#c00000',
            lineColor: '#c00000',
            lineWidth: 2
          }

        },

        {
          y: 22.5,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: 'none',
            lineColor: '#c00000',
            lineWidth: 2
          }

        }
      ],
      zoneAxis: 'x',
      zones: [{
        value: 6
      }, {
        dashStyle: 'Dash'
      }]
    },
    {
      marker: {
        enabled: false
      },
      zoneAxis: 'x',
      zones: [{
        value: 6
      }, {
        dashStyle: 'Dash'
      }],
      name: 'Asie centrale et Asie du Sud',
      type: 'line',
      color: '#00b050',
      zoneAxis: 'x',
      data: [
        {
          y: 13.7,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#00b050',
            lineColor: '#00b050',
            lineWidth: 2
          }
        }, 12.6, 11.9, 11.9, 12.9, 15.2, {
          y: 15.9,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#00b050',
            lineColor: '#00b050',
            lineWidth: 2
          }
        }, {
          y: 15.2,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: 'none',
            lineColor: '#00b050',
            lineWidth: 2
          }
        }
      ],
    },

    {
      marker: {
        enabled: false
      },
      zoneAxis: 'x',
      zones: [{
        value: 6
      }, {
        dashStyle: 'Dash'
      }],
      name: 'Asie de l’Ouest et Afrique du Nord',
      type: 'line',
      color: '#ffc000',
      zoneAxis: 'x',
      data: [
        {
          y: 7.4,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#ffc000',
            lineColor: '#ffc000',
            lineWidth: 2
          }
        }, 8, 8.1, 8.3, 8.2, 8.4, {
          y: 8.7,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#ffc000',
            lineColor: '#ffc000',
            lineWidth: 2
          }
        }, {
          y: 9.2,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: 'none',
            lineColor: '#595959',
            lineWidth: 2
          }
        }
      ],
    },
    {
      marker: {
        enabled: false
      },
      zoneAxis: 'x',
      zones: [{
        value: 6
      }, {
        dashStyle: 'Dash'
      }],
      name: 'Monde',
      type: 'line',
      color: '#595959',
      zoneAxis: 'x',
      data: [
        {
          y: 7.9,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#595959',
            lineColor: '#595959',
            lineWidth: 2
          }
        }, 7.8, 7.5, 7.6, 7.9, 8.9, {
          y: 9.3,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#595959',
            lineColor: '#595959',
            lineWidth: 2
          }
        }, {
          y: 9.2,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: 'none',
            lineColor: '#595959',
            lineWidth: 2
          }
        }
      ],
    },
    {
      marker: {
        enabled: false
      },
      zoneAxis: 'x',
      zones: [{
        value: 6
      }, {
        dashStyle: 'Dash'
      }],
      name: 'Amérique latine et Caraïbes',
      type: 'line',
      color: '#92d050',
      zoneAxis: 'x',
      data: [
        {
          y: 5.3,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#92d050',
            lineColor: '#92d050',
            lineWidth: 2
          }
        }, 6.1, 5.8, 5.9, 5.6, 6.5, {
          y: 7,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#92d050',
            lineColor: '#92d050',
            lineWidth: 2
          }
        }, {
          y: 6.5,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: 'none',
            lineColor: '#92d050',
            lineWidth: 2
          }
        }
      ],
    },

    {
      marker: {
        enabled: false
      },
      zoneAxis: 'x',
      zones: [{
        value: 6
      }, {
        dashStyle: 'Dash'
      }],
      name: 'Océanie',
      type: 'line',
      color: '#00b0f0',
      zoneAxis: 'x',
      data: [
        {
          y: 6.2,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#00b0f0',
            lineColor: '#00b0f0',
            lineWidth: 2
          }
        }, 6.1, 6.1, 6.4, 6.4, 6, {
          y: 6.6,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#00b0f0',
            lineColor: '#00b0f0',
            lineWidth: 2
          }
        }, {
          y: 7,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: 'none',
            lineColor: '#00b0f0',
            lineWidth: 2
          }
        }
      ],
    },
    {
      marker: {
        enabled: false
      },
      zoneAxis: 'x',
      zones: [{
        value: 6
      }, {
        dashStyle: 'Dash'
      }],
      name: 'Asie de l’Est et Asie du Sud-Est',
      type: 'line',
      color: '#0070c0',
      zoneAxis: 'x',
      data: [
        {
          y: 3.1,
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            fillColor: '#0070c0',
            lineColor: '#0070c0',
            lineWidth: 2
          }
        }, 2.8, 2.5, 2.5, null, null, null, null
      ],
    },
  ],

}
